import {
  ControllerSitInContentWrapper,
  ControllerSitInHeaderButtonWrapper,
  ControllerSitInHeaderInputWrapper,
  ControllerSitInHeaderWrapper,
  ControllerSitInMemberListBody,
  ControllerSitInMemberListHeader,
  ControllerSitInMemberListHeaderWrapper,
  ControllerSitInMemberListItem,
  ControllerSitInMemberListWrapper,
  ControllerSitInSortWrapper,
  ControllerSitInWrapper,
} from "./style";
import TimerControllerUserCount from "./components/user-count";
import { useCallback, useEffect, useRef, useState } from "react";
import { TimerControllerDropBox, TimerControllerHeaderTabs } from "../../style";
import { SitInTab } from "./hooks/use-tournament-participant";
import ControllerSitInReservationPopup from "./components/reservation";
import { useParticipantContext } from "./hooks/participant-context";
import {
  EntryType,
  TournamentParticipationDto,
} from "../../../../api/tournament-participant";
import { ControllerSitInMemberHistory } from "./components/member-history";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { dialogState } from "../../../../recoil/dialog.atom";
import { isRegistrationAvailable } from "../../../../utils/timer";
import { useControllerContext } from "../../hooks/controller-context";
import { isEventType } from "../../../../utils/tournament-type";
import PointPaidPopup from "../../../solution/components/point-paid";
import { isTournamentAccess } from "../../../../utils/owner";
import { pubState } from "../../../../recoil/pub.atom";

const TimerControllerSitIn = () => {
  const {
    tab,
    setTab,
    sort,
    setSort,
    isLoading,
    hasMoreData,
    currentPage,
    setCurrentPage,
    searchNickname,
    setSearchNickname,
    onSearchClick,
    participantList,
    sitInCount,
    sitOutCount,
    notSitInReservationCount,
    isReservationPopup,
    setIsReservationPopup,
    reloadData,
    isHistoryPopup,
    isPrizePopup,
    setIsPrizePopup,
    handleBuyIn,
    handleSitOut,
    handleOpenHistory,
    handleReEntry,
    handleParticipantDelete,
  } = useParticipantContext();
  const { data } = useControllerContext();
  const pub = useRecoilValue(pubState);
  // 드롭다운 상태
  const [openSitInSort, setOpenSitInSort] = useState<boolean>(false);
  const [openMoreId, setOpenMoreId] = useState<number>(-1);
  // 스크롤 페이징
  const observerRef = useRef<HTMLDivElement>(null);

  const tabs = [
    { name: `싯인(${sitInCount})`, value: SitInTab.SIT_IN },
    { name: `싯아웃(${sitOutCount})`, value: SitInTab.SIT_OUT },
  ];

  const sitInSortList = [
    { name: "가나다순", value: "name" },
    { name: "최신순", value: "id" },
  ];

  // 삭제 로직
  const handleMoreItem = (item: TournamentParticipationDto) => {
    setOpenMoreId(-1);
    handleParticipantDelete(item.memberId);
  };

  const moreItems = [{ name: "삭제", onClick: handleMoreItem }];

  // 스크롤 페이징
  const handleObserver = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const target = entries[0];
      if (target.isIntersecting && hasMoreData && !isLoading) {
        setCurrentPage(currentPage + 1);
      }
    },
    [hasMoreData, isLoading],
  );

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, {
      threshold: 1.0,
    });

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [handleObserver]);

  // 삭제 / 싯인 목록 보기
  const handleMore = (id: number, e: React.MouseEvent) => {
    e.stopPropagation();
    if (openMoreId === id) {
      setOpenMoreId(-1);
    } else {
      setOpenMoreId(id);
    }
  };

  // 예약 싯인
  const handleReservationBuyIn = () => {
    if (data && !isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }

    setIsReservationPopup(true);
  };

  const handlePointPaid = () => {
    if (!data) return;
    if (!isTournamentAccess(data.id, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${data.id}에 대한 권한이 없습니다. `);
      return;
    }

    const isRegistration = isRegistrationAvailable(data);

    if (isRegistration) {
      alert("레지마감레벨 이후 시상이 가능합니다. ");
      return;
    }

    setIsPrizePopup(true);
  };

  return (
    <ControllerSitInWrapper onClick={(e) => handleMore(-1, e)}>
      {/* 예약자 목록 팝업 */}
      {isReservationPopup && <ControllerSitInReservationPopup />}
      {/* 이용 내역 목록 팝업 */}
      {isHistoryPopup && <ControllerSitInMemberHistory />}
      {/* 시상 팝업 */}
      {isPrizePopup && (
        <PointPaidPopup
          tournamentId={data?.id ?? 0}
          getData={reloadData}
          onClose={() => {
            setIsPrizePopup(false);
          }}
        />
      )}
      <TimerControllerUserCount />
      <ControllerSitInContentWrapper width="1087px" height="620px">
        <ControllerSitInHeaderWrapper>
          <TimerControllerHeaderTabs>
            {tabs.map((item, index) => (
              <div
                key={index}
                className={`button ${tab === item.value ? "select" : ""}`}
                onClick={() => setTab(item.value)}
              >
                {item.name}
              </div>
            ))}
          </TimerControllerHeaderTabs>
          <ControllerSitInHeaderButtonWrapper>
            {!isEventType(data?.tournamentType) && (
              <div className="text" onClick={handlePointPaid}>
                시상
              </div>
            )}
            <div className="text" onClick={handleReservationBuyIn}>
              예약자 싯인({notSitInReservationCount}명)
            </div>
            <ControllerSitInHeaderInputWrapper>
              <input
                value={searchNickname}
                onChange={(e) => setSearchNickname(e.target.value)}
                placeholder="닉네임을 검색하세요."
              />
              <img
                src="/image-web/controller/search_white.svg"
                alt="search"
                onClick={onSearchClick}
              />
            </ControllerSitInHeaderInputWrapper>
            <div className="button" onClick={handleBuyIn}>
              추가
            </div>
          </ControllerSitInHeaderButtonWrapper>
        </ControllerSitInHeaderWrapper>
        <ControllerSitInMemberListWrapper>
          <ControllerSitInSortWrapper isAbsolute={true}>
            <div
              className="box"
              onClick={() => setOpenSitInSort(!openSitInSort)}
            >
              {sort === "id" ? "최신순" : "가나다순"}
              <img src="/image-web/controller/drop_down.svg" alt="down" />
            </div>
            {openSitInSort && (
              <TimerControllerDropBox top="40px">
                {sitInSortList.map((item, i) => (
                  <div
                    className={`item ${item.value === sort ? "selected" : ""}`}
                    onClick={() => {
                      setSort(item.value);
                      setOpenSitInSort(false);
                    }}
                    key={i}
                  >
                    {item.name}
                  </div>
                ))}
              </TimerControllerDropBox>
            )}
          </ControllerSitInSortWrapper>
          <ControllerSitInMemberListHeaderWrapper>
            {Array.from({ length: 2 }, (_, index) => (
              <ControllerSitInMemberListHeader key={index}>
                <div className="name">닉네임</div>
                <div className="count">리엔트리</div>
                <div className="count">애드온</div>
              </ControllerSitInMemberListHeader>
            ))}
          </ControllerSitInMemberListHeaderWrapper>
          <ControllerSitInMemberListBody>
            {participantList.map((item, index) => (
              <ControllerSitInMemberListItem
                key={index}
                ref={index === currentPage * 19 ? observerRef : undefined}
                onClick={() => handleOpenHistory(item)}
              >
                <div className="name">{item.nickname}</div>
                <div className="count">{item.rebuyCount}</div>
                <div className="count">
                  {item.addonIsCount}
                  {item.addonNotCount ? `(${item.addonNotCount})` : ""}
                </div>
                {tab === SitInTab.SIT_IN ? (
                  <>
                    <div
                      className="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleReEntry(item, EntryType.RE_BUY);
                      }}
                    >
                      리엔트리
                    </div>
                    <div
                      className="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleReEntry(item, EntryType.ADD_ON);
                      }}
                    >
                      애드온
                    </div>
                    <div
                      className="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSitOut(item, true);
                      }}
                    >
                      싯아웃
                    </div>
                    <div
                      className="more"
                      onClick={(e) => handleMore(item.id, e)}
                    >
                      <img src="/image-web/controller/more.svg" alt="more" />
                      <ControllerSitInSortWrapper isAbsolute={true}>
                        {openMoreId === item.id && (
                          <TimerControllerDropBox top="20px" left="-90px">
                            {moreItems.map((more, i) => (
                              <div
                                className="item"
                                onClick={() => more.onClick(item)}
                                key={i}
                              >
                                {more.name}
                              </div>
                            ))}
                          </TimerControllerDropBox>
                        )}
                      </ControllerSitInSortWrapper>
                    </div>
                  </>
                ) : (
                  <div className="return">
                    <img
                      src="/image-web/tournament/reset.svg"
                      alt="reset"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSitOut(item, false);
                      }}
                    />
                  </div>
                )}
              </ControllerSitInMemberListItem>
            ))}
          </ControllerSitInMemberListBody>
        </ControllerSitInMemberListWrapper>
      </ControllerSitInContentWrapper>
    </ControllerSitInWrapper>
  );
};

export default TimerControllerSitIn;
